import React from 'react';
import { renderMarkdown } from '../lib/markdown';

/**
 * Render rich text content that may be:
 *  - HTML string (from TipTap editor) — rendered safely via dangerouslySetInnerHTML
 *  - Markdown legacy — converted via renderMarkdown helper
 *  - Plain text — wrapped as paragraph
 *
 * Auto-detects the input type to maintain backward compatibility with legacy products.
 */
const RichContent = ({ value, style, className = '' }) => {
    if (!value) return null;
    const trimmed = String(value).trim();
    const looksLikeHtml = /<\/?[a-z][^>]*>/i.test(trimmed);
    if (looksLikeHtml) {
        return (
            <div
                style={style}
                className={`cert-rich-content ${className}`}
                dangerouslySetInnerHTML={{ __html: trimmed }}
            />
        );
    }
    return (
        <div style={style} className={`cert-rich-content ${className}`}>
            {renderMarkdown(trimmed)}
        </div>
    );
};

export default RichContent;
